export const GTM_LABEL_SIGN_UP = 'sign_up';
export const GTM_LABEL_LOGIN = 'login';
export const GTM_LABEL_PROLONGATION = 'prolongation';
export const GTM_LABEL_REFINANCING = 'refinancing';
export const GTM_LABEL_LOAN_REPAYMENT = 'loan_repayment';
export const GTM_LABEL_LOAN_PARTIAL_REPAYMENT = 'partial_repayment';
export const GTM_LABEL_LOAN_REPEAT_APPLICATION = 'repeat_application';
export const GTM_LABEL_LOAN_REPEAT_LOAN = 'repeat_loan';
export const GTM_LABEL_LOAN_REPEAT_FIRST_LOAN = 'repeat_application_first_loan';
export const GTM_LABEL_SETUP = 'setup';
export const GTM_LABEL_SKIP = 'skip';
export const GTM_LABEL_LOAN_FIRST_LOAN = 'first_loan';
export const GTM_EVENT_ERROR_DATA = 'error_data'
